/**
 * @pageName Staff
 * @slotType dashboard plugin
 */
export type StaffBannerParams = {
  /* Staff Resource ID.*/ staffResourceId: string;
  /* Staff ID.*/ staffId: string;
};
/**
 * @pageName Staff
 * @slotType dashboard menu plugin
 */
export type StaffMainMoreActionsMenuParams = {};
/**
 * @pageName Staff
 * @slotType dashboard menu plugin
 */
export type StaffItemMoreActionsMenuParams = {
  /* Staff Resource ID.*/ staffResourceId: string;
  /* Staff ID.*/ staffId: string;
};
